export enum GroupListsFilterCriteria {
  ACTIVE_GROUP_PILL = 'ACTIVE_GROUP_PILL',
  EXPANDED_GROUP_ROWS = 'EXPANDED_GROUP_ROWS',
  CURRENT_GROUP_PAGE = 'CURRENT_GROUP_PAGE'
}
